import script from "./App.vue?vue&type=script&setup=true&lang=js"
export * from "./App.vue?vue&type=script&setup=true&lang=js"

import "./App.vue?vue&type=style&index=0&id=3404f9cf&lang=less"
import "./App.vue?vue&type=style&index=1&id=3404f9cf&lang=less&scoped=true"

import exportComponent from "/data/web/pay/thpay/thpay-h5/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3404f9cf"]])

export default __exports__